var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 d-flex flex-column",staticStyle:{"height":"100%"},attrs:{"fluid":"","no-gutters":""}},[_c('the-navbar-top-panel'),_c('the-navbar-tools-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }